// Messages for operator/shipments/DocumentUploadModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.document_modal.doc_type.hbl': 'House B/L',
  'operator.document_modal.doc_type.invoice': 'Invoice',
  'operator.document_modal.doc_type.packing': 'Packing list',
  'operator.document_modal.doc_type.customs': 'Customs',
  'operator.document_modal.doc_type.other': 'Other',
  'operator.document_modal.upload_many': 'Upload {count} documents',
  'operator.document_modal.batch_titles': 'Each document is named after its file.',
  'operator.document_modal.visibility.internal': 'Internal — operators only',
  'operator.document_modal.visibility.shared': 'Shared — visible to customer',
  'operator.document_modal.title.edit': 'Edit document',
  'operator.document_modal.title.upload': 'Upload document',
  'operator.document_modal.cancel': 'Cancel',
  'operator.document_modal.uploading': 'Uploading… {percent}%',
  'operator.document_modal.save_changes': 'Save changes',
  'operator.document_modal.upload': 'Upload',
  'operator.document_modal.field.replace_file': 'Replace file (optional)',
  'operator.document_modal.field.file': 'File',
  'operator.document_modal.file_aria': 'File',
  'operator.document_modal.keeping_file':
    'Keeping the current file — choose a new one only to replace it.',
  'operator.document_modal.field.title': 'Title',
  'operator.document_modal.title_placeholder': 'House Bill of Lading',
  'operator.document_modal.field.type': 'Type',
  'operator.document_modal.type_aria': 'Document type',
  'operator.document_modal.field.visibility': 'Visibility',
  'operator.document_modal.visibility_aria': 'Visibility',
}

export const zhTW = {
  'operator.document_modal.doc_type.hbl': 'House B/L',
  'operator.document_modal.doc_type.invoice': '發票',
  'operator.document_modal.doc_type.packing': '裝箱單',
  'operator.document_modal.doc_type.customs': '報關',
  'operator.document_modal.doc_type.other': '其他',
  'operator.document_modal.upload_many': '上傳 {count} 份文件',
  'operator.document_modal.batch_titles': '每份文件將以其檔名命名。',
  'operator.document_modal.visibility.internal': '內部 — 僅限操作人員',
  'operator.document_modal.visibility.shared': '共享 — 客戶可見',
  'operator.document_modal.title.edit': '編輯文件',
  'operator.document_modal.title.upload': '上傳文件',
  'operator.document_modal.cancel': '取消',
  'operator.document_modal.uploading': '上傳中… {percent}%',
  'operator.document_modal.save_changes': '儲存變更',
  'operator.document_modal.upload': '上傳',
  'operator.document_modal.field.replace_file': '替換檔案（選填）',
  'operator.document_modal.field.file': '檔案',
  'operator.document_modal.file_aria': '檔案',
  'operator.document_modal.keeping_file': '保留目前的檔案 — 僅在需要替換時才選擇新檔案。',
  'operator.document_modal.field.title': '標題',
  'operator.document_modal.title_placeholder': 'House Bill of Lading',
  'operator.document_modal.field.type': '類型',
  'operator.document_modal.type_aria': '文件類型',
  'operator.document_modal.field.visibility': '可見性',
  'operator.document_modal.visibility_aria': '可見性',
}
